import { doctrineAnalytics } from '../utils/analyticsUtils';
import { JOBS_TO_RESTRICT } from '../../../shared/constants/requestDecision';
import {
  getParametersFromUrl,
  buildUrlWithParameters,
} from '../utils/url-utils/urlUtils';

const putToLower = (string: string) => (string ? string.toLowerCase() : '');
const mapToLower = (arr: string[]) => arr.map(putToLower);

export function checkJobRestriction(job: string) {
  if (!job) return false;
  const lowerJob = putToLower(job);
  const lowerJobsToRestrict = mapToLower(JOBS_TO_RESTRICT);
  return lowerJobsToRestrict.includes(lowerJob);
}

export function addNewPositionToUrl(position: number) {
  const params = getParametersFromUrl(window.location.search);
  window.history.replaceState(
    {},
    '',
    buildUrlWithParameters(window.location.pathname, { ...params, position }),
  );
}

export function askForDecisionAnalytics(source: string, otherMetas: {} = {}) {
  return () => {
    doctrineAnalytics('AskDecisionClicked', { source, ...otherMetas });
  };
}

export function trackCopyReference(source: string, docId: string) {
  doctrineAnalytics('Decision ButtonCopyReferenceClicked', {
    source,
    reportOriginalQueryKey: true,
    doc_id: docId,
  });
}
